/* eslint-disable react/prop-types */
import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

import { makeStyles } from '@mui/styles';
import styles from './styles';

const useStyles = makeStyles(styles);

export default function Item({ destination, state, icon, name }) {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Link to={destination} state={state}>
        <Box className={classes.descritionButton}>
          <Box className={classes.imageWrapper}>{icon}</Box>
          <Box className={classes.details}>
            <Typography className={classes.title} variant="h1">
              {name}
            </Typography>
          </Box>
        </Box>
      </Link>
    </Box>
  );
}
